// Thank-you page after a webinar registration (/webinar/dakujeme). Hidden: noindex, not in nav or sitemap.
import { Link } from 'react-router-dom';
import SEO from '@/components/SEO';
import { CalendarPlus, CheckCircle2, Mail } from 'lucide-react';
import { WEBINAR, googleCalendarUrl, downloadIcs } from './Webinar';

const CONTACT_EMAIL = 'hello@stratodata.eu';
const LOGO = '/lovable-uploads/2bbaa664-89c2-45e5-80a8-fd888d8066c0.png';

const WebinarThanks = () => (
  <div className="flex flex-col min-h-screen bg-[#2A1E47] text-white">
    <SEO title="Ďakujeme za registráciu" description="Miesto na webinári Stratodata máte rezervované." canonical="/webinar/dakujeme" noIndex />

    <header className="px-6 md:px-10 py-5 md:py-6">
      {/* Same logo twice: planet keeps brand colours, wordmark turned white for the dark background */}
      <Link to="/" className="relative inline-block hover:opacity-90 transition-opacity">
        <img src={LOGO} alt="Stratodata" className="h-8 md:h-10 [clip-path:inset(0_68%_0_0)]" />
        <img src={LOGO} alt="" aria-hidden className="absolute inset-0 h-8 md:h-10 brightness-0 invert [clip-path:inset(0_0_0_32%)]" />
      </Link>
    </header>

    <main className="flex-1 flex items-center px-6 md:px-10 py-12">
      <div className="max-w-2xl mx-auto text-center">
        <CheckCircle2 className="w-16 h-16 text-[#FF6B35] mx-auto mb-6" />
        <h1 className="text-4xl md:text-6xl font-bold tracking-tight mb-6">
          Ďakujeme, miesto máte <span className="text-[#FF6B35]">rezervované</span>
        </h1>
        <p className="text-lg md:text-xl text-white/85 leading-relaxed mb-3">
          Potvrdzovací e-mail vám pošleme najneskôr do nasledujúceho pracovného dňa.
        </p>
        <p className="text-base text-white/70 leading-relaxed mb-10">
          Ak dovtedy nepríde, pozrite aj priečinok so spamom, alebo nám napíšte na{' '}
          <a href={`mailto:${CONTACT_EMAIL}`} className="font-semibold text-white underline decoration-[#FF6B35] underline-offset-4 hover:text-[#FF6B35]">
            {CONTACT_EMAIL}
          </a>
          .
        </p>

        <div className="rounded-2xl bg-white/5 border border-white/10 p-6 md:p-8">
          <p className="text-sm font-semibold uppercase tracking-wide text-[#FF6B35] mb-2">Uložte si termín</p>
          <p className="text-xl md:text-2xl font-bold mb-6">
            {WEBINAR.dateLabel.charAt(0).toUpperCase() + WEBINAR.dateLabel.slice(1)} · {WEBINAR.timeLabel}
            <span className="block text-base font-normal text-white/70 mt-1">{WEBINAR.durationLabel} · online</span>
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href={googleCalendarUrl()}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-[#FF6B35] text-white font-semibold hover:bg-[#FF6B35]/90 transition-colors"
            >
              <CalendarPlus className="w-5 h-5" />
              Google Kalendár
            </a>
            <button
              type="button"
              onClick={downloadIcs}
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg border border-white/30 text-white font-semibold hover:bg-white hover:text-[#2A1E47] transition-colors"
            >
              <CalendarPlus className="w-5 h-5" />
              Outlook / Apple (.ics)
            </button>
          </div>
        </div>

        <p className="mt-10 inline-flex items-center gap-2 text-sm text-white/60">
          <Mail className="w-4 h-4" />
          Odkaz na pripojenie vám pošleme e-mailom deň pred webinárom.
        </p>
      </div>
    </main>
  </div>
);

export default WebinarThanks;
